import { useState, useEffect, useRef } from "react"
import { Modal, Button } from "react-bootstrap"
import { millisecondsToHoursAndMinutes } from "../../utilities/dateUtilities"

export const SessionTimeout = () => {
    const [showTimeoutModal, setShowTimeoutModal] = useState(false)
    const [idleTime, setIdleTime] = useState(0);
    const timerRef = useRef(null);
    const debounceRef = useRef(null);
    const idleStartRef = useRef(null);
    const idleIntervalRef = useRef(null);

    const userInteractionEventsForIdleTimer = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    const resetTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        if (idleIntervalRef.current) {
            clearInterval(idleIntervalRef.current);
        }
        setIdleTime(0);
        idleStartRef.current = null;
        debounceRef.current = setTimeout(() => {
            startIdleTimer();
        }, 500);
    };

    const startIdleTimer = () => {

        timerRef.current = setTimeout(() => {
            idleStartRef.current = Date.now();
            idleIntervalRef.current = setInterval(() => {
                if (idleStartRef.current) {
                    const elapsed = Date.now() - idleStartRef.current;
                    setIdleTime(elapsed);
                }
            }, 60000);

            userInteractionEventsForIdleTimer.forEach(event => {
                document.removeEventListener(event, resetTimer);
            });
            setShowTimeoutModal(true)
        }, 10800000);
    };

    useEffect(() => {
        startIdleTimer();

        userInteractionEventsForIdleTimer.forEach(event => {
            document.addEventListener(event, resetTimer);
        });

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
            if (idleIntervalRef.current) {
                clearInterval(idleIntervalRef.current);
            }
            userInteractionEventsForIdleTimer.forEach(event => {
                document.removeEventListener(event, resetTimer);
            });
        };
    }, [])
    return <>
        {
            showTimeoutModal &&
            <Modal show centered>
                <Modal.Header>
                    <Modal.Title className="d-flex gap-2 align-items-center">Session inactive</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="font-weight-semi-bold mt-1 mb-2">
                        Your session has been inactive for { millisecondsToHoursAndMinutes(idleTime).hours } { millisecondsToHoursAndMinutes(idleTime).hours === 1 ? <>hour</> : <>hours</> } and { millisecondsToHoursAndMinutes(idleTime).minutes } { millisecondsToHoursAndMinutes(idleTime).minutes === 1 ? <>minute</> : <>minutes</> }. To continue, please click the refresh button below.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant='primary' onClick={ () => window.location.reload() }>Refresh</Button>
                </Modal.Footer>
            </Modal>
        }
    </>
}